import { Observable } from "rxjs";
import api from "@/services/api-config/rxjs-config";
import { QueryParams } from "@/models/query-params.model";

export class FeedbackRest {
  sendMaterialFeedback(
    studentId: string,
    materialId: string,
    courseId: string,
    data: any
  ): Observable<any> {
    const url: string = `/course-state/${courseId}/${studentId}/feedbacks?material=${materialId}&like=${data.like}`;
    return api.put(url, data, {}, "/graphs");
  }
  sendLearningObjectFeedback(
    studentId: string,
    courseId: string,
    data: any,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/course-state/${courseId}/${studentId}/events/feedbacks`;
    return api.post(url, data, params, "/graphs");
  }
}
